<template>
  <div
    :class="{ is_mobile: !$tools.isPc() }"
    class="page_middle_container page_middle_project_detail"
  >
    <div class="page_middle_title">发票申请二次审核</div>

    <div class="page_middle_content">
      <div class="page_middle_body">
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>项目号：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              {{ data.project_number }}
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>付款方：
            </div>
            <div class="page_middle_row_value">
              <el-select
                :disabled="true"
                v-model="data.customer_company"
                placeholder="根据结算日期自动显示"
              >
              </el-select>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>发票类型：
            </div>
            <div class="page_middle_row_value">
              <el-select
                disabled
                v-model="data.invoice_type"
                placeholder="请选择发票类型"
              >
                <el-option
                  v-for="(item, index) in config.invoiceType"
                  :key="index"
                  :value="index"
                  :label="item"
                ></el-option>
                <!-- <el-option :value="1" label="增值税专用发票"></el-option> -->
              </el-select>
            </div>
          </div></div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>发票类目：
            </div>
            <div class="page_middle_row_value">
              <el-select
                disabled
                v-model="data.invoice_category"
                filterable
                placeholder="请选择发票类目"
              >
                <el-option
                  v-for="(item, index) in invoiceTypeSet"
                  :key="index"
                  :value="item"
                  :label="item"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>发票明细：
            </div>
            <div class="page_middle_row_value">
              <el-select
                disabled
                v-model="data.invoice_detail"
                filterable
                placeholder="请选择发票明细"
              >
                <el-option
                  v-for="(item, index) in invoiceDetailList"
                  :key="index"
                  :value="item"
                  :label="item"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>结算日期：
            </div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                v-model="data.settlement_date"
                placeholder="请输入结算日期"
              ></el-input>
            </div>
          </div>
        </div>
        <div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required">*</span>发票金额：
              </div>
              <div class="page_middle_row_value" style="padding-left: 15px;">
                {{ data.invoice_amount || "根据结算日期自动显示" }}
              </div>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td" style="align-items: flex-start">
            <div class="page_middle_row_key">补充信息：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                type="textarea"
                v-model="data.supplementary_information"
                rows="4"
                placeholder="请输入补充信息"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              确认开票信息证明材料：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              <div v-if="data.evidence">
                <div v-for="(item, index) in evidence" :key="index" style="margin-bottom: 5px;">
                  <span class="global_link" @click="openLink(item)">
                    {{ $tools.getFileNameFromURL(item) }}
                  </span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
        </div>
        <div v-if="data.secondary_examine_status == 0 && !query.isWatch">
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required">*</span>二次审批结果：
              </div>
              <div class="page_middle_row_value">
                <el-select
                  v-model="secondAuditData.secondary_examine_status"
                  placeholder="请选择审批结果"
                >
                  <el-option :value="1" label="通过"></el-option>
                  <el-option :value="2" label="驳回"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required" v-if="secondAuditData.secondary_examine_status == 2">*</span>二次审核审批备注：
              </div>
              <div class="page_middle_row_value">
                <el-input
                  v-model.trim="secondAuditData.secondary_examine_reason"
                  placeholder="请输入审批备注"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                二次审批结果：
              </div>
              <div class="page_middle_row_value" style="padding-left: 15px;display: flex;align-items: center;">
                <el-icon style="font-size: 4vw;color: #67c23a;margin-right: 5px;" v-if="data.secondary_examine_status == 1"><SuccessFilled /></el-icon>
                <el-icon style="font-size: 4vw;color: red;margin-right: 5px;" v-if="data.secondary_examine_status == 2"><CircleCloseFilled /></el-icon>
                <span>
                  {{ $config.types.auditResult[data.secondary_examine_status] }}
                </span>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                二次审核审批备注：
              </div>
              <div class="page_middle_row_value"  style="padding-left: 15px;">
                {{ data.secondary_examine_reason }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="page_middle_buttongroup"
      v-if="data.secondary_examine_status == 0 && !query.isWatch"
    >
      <el-button type="primary" @click="doCommit" :loading="loading"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import { SuccessFilled, CircleCloseFilled } from "@element-plus/icons";
export default {
  name: "page_middle",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    SuccessFilled, 
    CircleCloseFilled 
  },
  data() {
    return {
      secondAuditData: {
        id: "",
        secondary_examine_status: "",
        secondary_examine_reason: "",
        operation_url: window.location.href,
      },
      data: {
        customer_id: 0,
        customer_company: "",
        invoice_type: "",
        invoice_category: "",
        invoice_detail: "",
        settlement_id: "",
        settlement_date: "",
        invoice_amount: "",
        supplementary_information: "",
        evidence: "",
      },
      config: {
        invoiceType: this.$config.types.invoiceType,
        isRequired: {
          isRequired: false,
          title: "请添加客户确认开票信息证明材料：",
        },
      },
      evidence: [],
      settlementList: [], //结算列表
      invoiceTypeList: [], //发票类目列表
      invoiceTypeSet: [], //发票类目列表(去重)
      invoiceDetailList: [], //发票明细列表
      loading: false,
    };
  },
  created() {
    this.query = { ...this.$route.query };
  },
  mounted() {
    this.getInvoiceDetailList();
    this.initData();
  },
  methods: {
    initData() {
      let url = this.$tools.getURL(this.$urls.invoice.get_apply_invoice, {
        id: this.query.id,
      });
      this.$axios
        .get(url)
        .then((res) => {
          if (!res.data.examine_status) {
            this.$router.push({
              path: "/auditError",
              query: {
                status: res.data.examine_status,
              },
            });
            return;
          }
          this.data = res.data;
          this.secondAuditData.id = res.data.id;
          this.evidence = this.data.evidence
            ? this.data.evidence.split(",")
            : [];
          this.getSettlementList(this.data.project_id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSettlementList(project_id) {
      let url = this.$tools.getURL(this.$urls.settlement.get_settlement_list, {
        project_id: project_id,
        page: 1,
        pagesize: 999,
      });
      this.$axios
        .get(url)
        .then((res) => {
          this.settlementList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getInvoiceDetailList() {
      this.$axios
        .get(this.$urls.invoice.get_invoice_detail_list)
        .then((res) => {
          this.invoiceTypeList = res.data;
          let arr = res.data.map((x) => x.invoice_category);
          this.invoiceTypeSet = Array.from(new Set(arr));
          this.invoiceDetailList = [];
        });
    },
    openLink(url) {
      this.$tools.downLoadFile(url);
    },
    verifyData() {
      if (!this.secondAuditData.secondary_examine_status) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (
        this.secondAuditData.secondary_examine_status == 2 &&
        !this.secondAuditData.secondary_examine_reason
      ) {
        this.$tips.error({ text: "请输入审批备注" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) {
        return;
      }
      this.loading = true;
      let url = this.$urls.invoice.audit_secondary_apply_invoice;
      this.$axios
        .post(url, this.secondAuditData)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tips.success({ text: "审核完成" });
          this.initData();
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>
<style>
.page_middle_project_detail .page_middle_row_value {
  display: flex;
  align-items: center;
}


.flex-column {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-justify-content-start {
  justify-content: start;
}

.zIndexBold {
  z-index: 1000;
  position: relative;
}

.is_mobile * {
  font-size: 1.25rem;
}

.is_mobile .page_middle_row {
  align-items: initial;
  flex-direction: column;
}

.is_mobile .page_middle_row .page_middle_row_td {
  margin-bottom: 10px;
}

.is_mobile .project_number_input {
  flex-direction: initial;
  align-items: center;
}

.is_mobile .page_middle_row_td_textarea .el-textarea {
  width: 60%;
}
</style>
  